import {apiVersion} from '.';

const baseURL = `${apiVersion.v2}/Authorize`;

export const {merchantLogin, GetApps, editApplications, automateCompliance, getVerifications} = {
    merchantLogin: `${baseURL}/login`,
    GetApps: `${baseURL}/GetApps`,
    editApplications: appId => `${baseURL}/EditApplicationService/${appId}`,
    automateCompliance: user => `${apiVersion.default}/${user}/verification/gateway`,
    getVerifications: user => `${apiVersion.default}/${user}/verification-gateway-services`,
};
